"use client";
import CurrencyDisplay from "@/app/components/currencyDisplay";
import UnknownHeavyShippingCharge from "@/app/ec/product/[basePath]/unknownHeavyShippingCharge";
import { HeavyShippingStatus } from "@/app/ec/product/[basePath]/vendor-options/configureVendorOptions";
import styles from "./heavyShippingMessage.module.scss";

/**
 * Renders the heavy-shipping surcharge messaging for a vendor option. Extracted
 * from PriceAndShipping so the same markup can be rendered in a different
 * position (e.g. the reorder pod renders it below the stock message rather than
 * inline with the price).
 */
function HeavyShippingMessage({ vendorOption, heavyShippingClassName = "" }: HeavyShippingMessageProps) {
  if (!vendorOption) {
    return null;
  }

  if (vendorOption.heavyShippingStatus == HeavyShippingStatus.HAS_KNOWN_HEAVY_SHIPPING) {
    return (
      <div className={`${heavyShippingClassName} ${styles.HeavyShippingMessage} nowrap`}>
        (Heavy shipping surcharge:&nbsp;
        <CurrencyDisplay value={vendorOption.heavyShipping.toFixed(2)} />)
      </div>
    );
  }

  if (vendorOption.heavyShippingStatus == HeavyShippingStatus.NO_SURCHARGE_MESSAGE) {
    return <div className={heavyShippingClassName}> &nbsp;No heavy shipping surcharge</div>;
  }

  if (vendorOption.heavyShippingStatus == HeavyShippingStatus.HAS_UNKNOWN_HEAVY_SHIPPING) {
    return <UnknownHeavyShippingCharge vendorOption={vendorOption} heavyShippingClassName={heavyShippingClassName} />;
  }

  return null;
}

export default HeavyShippingMessage;

type HeavyShippingMessageProps = {
  vendorOption?: VendorOptionState;
  heavyShippingClassName?: string;
};
